import i18n from 'i18next'
import lodash from 'lodash'
import { initReactI18next } from 'react-i18next'
import moment from 'moment'

import { getBrowserLanguage } from '../../../1stlog-ui/src/utils'

global.defaultLanguage =
  lodash.get(global, 'currentUser.user.language') ||
  lodash.get(global, 'currentUser.language') ||
  getBrowserLanguage()

console.log('Translation/i18n.js defaultLanguage', global.defaultLanguage)

i18n.use(initReactI18next).init({
  // resources,
  lng: global.defaultLanguage,
  languages: ['de', 'en', 'fr', 'it', 'nl', 'pl', 'ru', 'hr', 'sr', 'tr'],
  fallbackLng: 'de',
  keySeparator: false,
  debug: false,
  // ns: ["translation"],
  // defaultNS: "translation",
  interpolation: {
    escapeValue: false,
  },
})

i18n.on('languageChanged', (lng) => {
  console.log('Translation/i18n.js i18n.on("languageChanged")', {
    lng,
    bundleProof: i18n.getResourceBundle(i18n.language, 'translation')?.[
      'nba_new_address_adminsitration_updated'
    ],
    functionProof: i18n.t('nba_new_address_adminsitration_updated'),
  })
  moment.locale(lng)
})

if (/showTranslationKeys/.test(window.location)) {
  const originalT = i18n.t
  i18n.t = function (key, ...rest) {
    const result = originalT.apply(this, arguments)
    return `[${key}]${result}`
  }
}

global.i18n = i18n

global.t = i18n.t

export default i18n
